export enum TransportationType {
  Train = "Train",
  Flight = "Flight",
  Bus = "Bus",
  Boat = "Boat",
  Taxi = "Taxi",
  Any = "Any"
}

export enum TravelRequestStatusType {
  Open = "Open",
  Closed = "Closed",
}
